// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   TextField,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Typography,
//   Snackbar,
//   Alert,
//   Container,
//   Card,
//   CardContent,
//   CardHeader,
//   IconButton,
//   InputAdornment,
//   Divider,
//   Stepper,
//   Step,
//   StepLabel,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Avatar,
//   Chip,
//   Fab,
//   useMediaQuery,
//   useTheme,
//   alpha,
//   styled,
//   Input,
//   CardActions,
//   Badge,
//   Tooltip,
//   LinearProgress,
// } from "@mui/material";
// import {
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   CloudUpload as CloudUploadIcon,
//   PhotoCamera,
//   Visibility,
//   Close,
//   Save,
//   Add,
//   Person,
//   Home,
//   AccountBalance,
//   Fingerprint,
//   Share,
//   CheckCircle,
//   ExpandMore,
//   ExpandLess,
//   Verified,
//   LocationOn,
//   AccountBalanceWallet,
//   LinkedIn,
//   Facebook,
//   Twitter,
//   Instagram,
//   WhatsApp,
//   Email,
//   Phone,
//   Cake,
//   Bloodtype,
//   Favorite,
//   Work,
//   School,
//   Security,
//   CloudDone,
//   Description,
//   Assignment,
//   CreditCard,
//   LocalAtm,
//   DriveEta,
//   Badge as BadgeIcon,
//   HowToReg,
//   ContactMail,
//   ContactPhone,
//   Language,
// } from "@mui/icons-material";

// // Styled Components
// const PremiumCard = styled(Card)(({ theme }) => ({
//   borderRadius: 20,
//   background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.05)} 100%)`,
//   boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//   overflow: 'hidden',
//   position: 'relative',
//   '&:before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     height: 4,
//     background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//   }
// }));

// const GradientButton = styled(Button)(({ theme }) => ({
//   background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
//   border: 0,
//   borderRadius: 12,
//   color: 'white',
//   height: 48,
//   padding: '0 30px',
//   fontWeight: 600,
//   letterSpacing: '0.5px',
//   boxShadow: `0 3px 20px ${alpha(theme.palette.primary.main, 0.3)}`,
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-2px)',
//     boxShadow: `0 5px 25px ${alpha(theme.palette.primary.main, 0.4)}`,
//   }
// }));

// const SectionCard = styled(Card)(({ theme }) => ({
//   borderRadius: 16,
//   background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.03)} 100%)`,
//   border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     borderColor: alpha(theme.palette.primary.main, 0.2),
//     boxShadow: `0 6px 20px ${alpha(theme.palette.common.black, 0.08)}`,
//   }
// }));

// const ProfileAvatar = styled(Avatar)(({ theme }) => ({
//   width: 160,
//   height: 160,
//   border: `4px solid ${theme.palette.background.paper}`,
//   boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.15)}`,
//   position: 'relative',
//   '&:after': {
//     content: '""',
//     position: 'absolute',
//     top: -4,
//     left: -4,
//     right: -4,
//     bottom: -4,
//     borderRadius: '50%',
//     border: `2px solid ${theme.palette.primary.main}`,
//     animation: 'ripple 2s infinite',
//   },
//   '@keyframes ripple': {
//     '0%': {
//       transform: 'scale(1)',
//       opacity: 1,
//     },
//     '100%': {
//       transform: 'scale(1.1)',
//       opacity: 0,
//     },
//   }
// }));

// const AnimatedSectionHeader = styled(Box)(({ theme, expanded }) => ({
//   background: expanded 
//     ? `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
//     : `linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.9)} 0%, ${alpha(theme.palette.primary.dark, 0.9)} 100%)`,
//   color: 'white',
//   padding: theme.spacing(2, 3),
//   borderRadius: 12,
//   marginBottom: theme.spacing(3),
//   cursor: 'pointer',
//   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//   boxShadow: expanded 
//     ? `0 4px 20px ${alpha(theme.palette.primary.main, 0.3)}`
//     : `0 2px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
//   '&:hover': {
//     transform: 'translateY(-2px)',
//     boxShadow: `0 6px 25px ${alpha(theme.palette.primary.main, 0.4)}`,
//   }
// }));

// const PremiumTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: 10,
//     transition: 'all 0.3s ease',
//     '&:hover': {
//       '& .MuiOutlinedInput-notchedOutline': {
//         borderColor: theme.palette.primary.main,
//         borderWidth: 2,
//       }
//     },
//     '&.Mui-focused': {
//       '& .MuiOutlinedInput-notchedOutline': {
//         borderColor: theme.palette.primary.main,
//         borderWidth: 2,
//         boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.1)}`,
//       }
//     }
//   },
//   '& .MuiInputLabel-root': {
//     fontWeight: 500,
//   }
// }));

// const DocumentCard = styled(Card)(({ theme, required }) => ({
//   borderRadius: 12,
//   border: `2px solid ${required 
//     ? alpha(theme.palette.primary.main, 0.2) 
//     : alpha(theme.palette.grey[400], 0.2)}`,
//   transition: 'all 0.3s ease',
//   position: 'relative',
//   overflow: 'visible',
//   '&:hover': {
//     transform: 'translateY(-4px)',
//     borderColor: required 
//       ? theme.palette.primary.main 
//       : theme.palette.grey[600],
//     boxShadow: `0 8px 25px ${alpha(theme.palette.common.black, 0.1)}`,
//   },
//   '&:before': required ? {
//     content: '"Required"',
//     position: 'absolute',
//     top: -10,
//     right: -10,
//     background: theme.palette.primary.main,
//     color: 'white',
//     fontSize: '0.7rem',
//     padding: '2px 8px',
//     borderRadius: 10,
//     fontWeight: 'bold',
//     boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
//     zIndex: 1,
//   } : {}
// }));

// const PersonalDetailsForm = () => {
//   // State management
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     fatherName: "",
//     motherName: "",
//     dateOfBirth: "",
//     email: "",
//     phoneNumber: "",
//     alternativePhoneNumber: "",
//     gender: "",
//     bloodGroup: "",
//     maritalStatus: "",
//     addresses: [],
//     bankDetails: [],
//     socialProfiles: {},
//     profilePhoto: null,
//   });
//   const [addresses, setAddresses] = useState([]);
//   const [openAddressDialog, setOpenAddressDialog] = useState(false);
//   const [openBankDialog, setOpenBankDialog] = useState(false);
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [bankOption, setBankOption] = useState("existing");
//   const [activeStep, setActiveStep] = useState(0);
//   const [expandedSections, setExpandedSections] = useState({
//     personal: true,
//     address: false,
//     kyc: false,
//     bank: false,
//     social: false,
//   });
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [progress, setProgress] = useState(25);
//   const [uploadProgress, setUploadProgress] = useState({});

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   // Social media icons mapping
//   const socialIcons = {
//     linkedIn: <LinkedIn sx={{ color: '#0077B5' }} />,
//     facebook: <Facebook sx={{ color: '#4267B2' }} />,
//     twitter: <Twitter sx={{ color: '#1DA1F2' }} />,
//     instagram: <Instagram sx={{ color: '#E4405F' }} />,
//     whatsapp: <WhatsApp sx={{ color: '#25D366' }} />,
//   };

//   // Document lists
//   const documents = [
//     { label: "Aadhar Card", required: true, fieldName: "aadharCard", icon: <BadgeIcon />, color: "#4CAF50" },
//     { label: "PAN Card", required: true, fieldName: "panCard", icon: <CreditCard />, color: "#2196F3" },
//     { label: "Driving License", required: false, fieldName: "drivingLicense", icon: <DriveEta />, color: "#FF9800" },
//     { label: "Passport", required: false, fieldName: "passport", icon: <Description />, color: "#9C27B0" },
//     { label: "Voter ID", required: false, fieldName: "voterId", icon: <HowToReg />, color: "#F44336" },
//   ];

//   const socialProfiles = [
//     { label: "LinkedIn", required: false, type: "url", fieldName: "linkedIn", icon: socialIcons.linkedIn },
//     { label: "Facebook", required: false, type: "url", fieldName: "facebook", icon: socialIcons.facebook },
//     { label: "Twitter", required: false, type: "url", fieldName: "twitter", icon: socialIcons.twitter },
//     { label: "Instagram", required: false, type: "url", fieldName: "instagram", icon: socialIcons.instagram },
//     { label: "WhatsApp", required: false, type: "tel", fieldName: "whatsapp", icon: socialIcons.whatsapp },
//   ];

//   const steps = ["Personal Details", "Address", "KYC", "Bank Details", "Social Profiles"];

//   // Calculate form completion percentage
//   const calculateProgress = () => {
//     let completed = 0;
//     let total = 0;
    
//     // Check personal details
//     const personalFields = ['firstName', 'lastName', 'email', 'phoneNumber', 'gender', 'dateOfBirth'];
//     personalFields.forEach(field => {
//       total++;
//       if (formData[field]) completed++;
//     });
    
//     // Check KYC documents
//     documents.forEach(doc => {
//       total++;
//       if (doc.required && formData.documents?.[doc.fieldName]) completed++;
//     });
    
//     const percentage = Math.round((completed / total) * 100);
//     setProgress(percentage);
//     return percentage;
//   };

//   // Handler functions
//   const handleImageUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Simulate upload progress
//       setUploadProgress(prev => ({ ...prev, profile: 0 }));
//       const interval = setInterval(() => {
//         setUploadProgress(prev => {
//           if (prev.profile >= 100) {
//             clearInterval(interval);
//             return prev;
//           }
//           return { ...prev, profile: prev.profile + 10 };
//         });
//       }, 50);

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setTimeout(() => {
//           setSelectedImage(reader.result);
//           setFormData(prev => ({
//             ...prev,
//             profilePhoto: reader.result,
//           }));
//           setUploadProgress(prev => ({ ...prev, profile: 100 }));
//           clearInterval(interval);
          
//           setTimeout(() => {
//             setUploadProgress(prev => ({ ...prev, profile: null }));
//           }, 1000);
//         }, 500);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleChange = (field, event) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: event.target.value,
//     }));
//     calculateProgress();
//   };

//   const handleSocialProfileChange = (field, event) => {
//     setFormData(prev => ({
//       ...prev,
//       socialProfiles: {
//         ...prev.socialProfiles,
//         [field]: event.target.value,
//       },
//     }));
//   };

//   const handleDocumentChange = (field, event) => {
//     setFormData(prev => ({
//       ...prev,
//       documents: {
//         ...prev.documents,
//         [field]: event.target.value,
//       },
//     }));
//     calculateProgress();
//   };

//   const handleEdit = (index) => {
//     // Edit functionality
//     console.log('Edit item:', index);
//   };

//   const handleDelete = (index) => {
//     // Delete functionality
//     console.log('Delete item:', index);
//   };

//   const handleUploadClick = (field) => {
//     document.getElementById(`fileInput-${field}`).click();
//   };

//   const handleFileChangePreview = (event, field) => {
//     const file = event.target.files[0];
//     if (file) {
//       // Simulate upload progress
//       setUploadProgress(prev => ({ ...prev, [field]: 0 }));
//       const interval = setInterval(() => {
//         setUploadProgress(prev => {
//           if (prev[field] >= 100) {
//             clearInterval(interval);
//             return prev;
//           }
//           return { ...prev, [field]: prev[field] + 20 };
//         });
//       }, 50);

//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setTimeout(() => {
//           setSelectedFile({ [field]: reader.result });
//           setUploadProgress(prev => ({ ...prev, [field]: 100 }));
//           clearInterval(interval);
          
//           setTimeout(() => {
//             setUploadProgress(prev => ({ ...prev, [field]: null }));
//           }, 1000);
//         }, 500);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         ...formData,
//         addresses: addresses,
//       };

//       const response = await fetch("http://10.10.222.56:8283/Personal/add", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) throw new Error("Failed to submit personal details");

//       const data = await response.json();
//       setSnackbar({
//         open: true,
//         message: "Personal details submitted successfully!",
//         severity: "success",
//       });
//       setProgress(100);
//     } catch (error) {
//       console.error("Error:", error);
//       setSnackbar({
//         open: true,
//         message: "Failed to submit. Please try again.",
//         severity: "error",
//       });
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const toggleSection = (section) => {
//     setExpandedSections(prev => ({
//       ...prev,
//       [section]: !prev[section]
//     }));
//   };

//   const renderSectionHeader = (title, icon, section) => (
//     <AnimatedSectionHeader 
//       expanded={expandedSections[section]}
//       onClick={() => toggleSection(section)}
//       sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         mb: 3,
//       }}
//     >
//       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//         <Box sx={{
//           background: 'rgba(255,255,255,0.2)',
//           borderRadius: '50%',
//           p: 1,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}>
//           {React.cloneElement(icon, { sx: { fontSize: 24 } })}
//         </Box>
//         <Typography variant="h6" sx={{ 
//           fontWeight: 600,
//           fontSize: isMobile ? '1rem' : '1.25rem'
//         }}>
//           {title}
//         </Typography>
//         {expandedSections[section] && (
//           <Chip 
//             icon={<Verified sx={{ fontSize: 16 }} />}
//             label="Complete"
//             size="small"
//             sx={{ 
//               background: 'rgba(255,255,255,0.2)',
//               color: 'white',
//               ml: 2,
//               '& .MuiChip-icon': { color: '#4CAF50' }
//             }}
//           />
//         )}
//       </Box>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         {expandedSections[section] ? 
//           <ExpandLess sx={{ fontSize: 28 }} /> : 
//           <ExpandMore sx={{ fontSize: 28 }} />
//         }
//       </Box>
//     </AnimatedSectionHeader>
//   );

//   const renderProfileUploadSection = () => (
//     <Box sx={{ 
//       display: 'flex', 
//       flexDirection: 'column', 
//       alignItems: 'center',
//       position: 'relative',
//     }}>
//       <Badge
//         overlap="circular"
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//         badgeContent={
//           <IconButton
//             component="label"
//             sx={{
//               backgroundColor: theme.palette.primary.main,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: theme.palette.primary.dark,
//               },
//               width: 40,
//               height: 40,
//               border: `3px solid ${theme.palette.background.paper}`,
//             }}
//           >
//             <CloudUploadIcon sx={{ fontSize: 20 }} />
//             <input
//               type="file"
//               accept="image/*"
//               hidden
//               onChange={handleImageUpload}
//             />
//           </IconButton>
//         }
//       >
//         <ProfileAvatar
//           src={selectedImage}
//           sx={{
//             width: 160,
//             height: 160,
//             mb: 2,
//           }}
//         >
//           {!selectedImage && (
//             <Box sx={{ 
//               display: 'flex', 
//               flexDirection: 'column', 
//               alignItems: 'center',
//               gap: 1 
//             }}>
//               <PhotoCamera sx={{ fontSize: 40, opacity: 0.7 }} />
//               <Typography variant="caption" sx={{ color: 'text.secondary' }}>
//                 Add Photo
//               </Typography>
//             </Box>
//           )}
//         </ProfileAvatar>
//       </Badge>
      
//       {uploadProgress.profile !== null && (
//         <Box sx={{ width: '100%', mt: 2 }}>
//           <LinearProgress 
//             variant="determinate" 
//             value={uploadProgress.profile}
//             sx={{
//               height: 6,
//               borderRadius: 3,
//               backgroundColor: alpha(theme.palette.primary.main, 0.1),
//               '& .MuiLinearProgress-bar': {
//                 background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 borderRadius: 3,
//               }
//             }}
//           />
//           {uploadProgress.profile < 100 && (
//             <Typography variant="caption" color="text.secondary" align="center" sx={{ display: 'block', mt: 1 }}>
//               Uploading... {uploadProgress.profile}%
//             </Typography>
//           )}
//           {uploadProgress.profile === 100 && (
//             <Typography variant="caption" color="success.main" align="center" sx={{ display: 'block', mt: 1 }}>
//               <CloudDone sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
//               Upload Complete
//             </Typography>
//           )}
//         </Box>
//       )}
      
//       <Typography 
//         variant="caption" 
//         color="text.secondary" 
//         align="center" 
//         sx={{ 
//           display: 'block', 
//           mt: 1,
//           maxWidth: 200 
//         }}
//       >
//         Supports JPEG, PNG • Max 2MB • 300x300px
//       </Typography>
//     </Box>
//   );

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       {/* Header with Progress */}
//       <Box sx={{ mb: 4 }}>
//         {/* <Typography 
//           variant="h4" 
//           sx={{ 
//             fontWeight: 800,
//             background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//             WebkitBackgroundClip: 'text',
//             WebkitTextFillColor: 'transparent',
//             mb: 1,
//           }}
//         >
//           Personal Profile Setup
//         </Typography>
//         <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
//           Complete your profile to unlock all features
//         </Typography> */}
        
       
//         {/* <Box sx={{ mb: 3 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//             <Typography variant="body2" color="text.secondary">
//               Profile Completion
//             </Typography>
//             <Typography variant="body2" color="primary" fontWeight={600}>
//               {progress}%
//             </Typography>
//           </Box>
//           <LinearProgress 
//             variant="determinate" 
//             value={progress}
//             sx={{
//               height: 8,
//               borderRadius: 4,
//               backgroundColor: alpha(theme.palette.primary.main, 0.1),
//               '& .MuiLinearProgress-bar': {
//                 background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 borderRadius: 4,
//               }
//             }}
//           />
//         </Box> */}
//       </Box>

//       {/* Stepper for Desktop */}
//       {!isMobile && (
//         <Box sx={{ mb: 4 }}>
//           <Stepper
//             activeStep={activeStep}
//             alternativeLabel
//             sx={{
//               '& .MuiStepLabel-root .Mui-completed': {
//                 color: theme.palette.primary.main,
//               },
//               '& .MuiStepLabel-root .Mui-active': {
//                 color: theme.palette.primary.main,
//               },
//               '& .MuiStepLabel-label': {
//                 fontWeight: 600,
//               },
//             }}
//           >
//             {steps.map((label, index) => (
//               <Step key={label}>
//                 <StepLabel 
//                   StepIconProps={{
//                     sx: {
//                       '&.Mui-completed': {
//                         color: theme.palette.primary.main,
//                       },
//                       '&.Mui-active': {
//                         color: theme.palette.primary.main,
//                       },
//                     }
//                   }}
//                 >
//                   <Typography variant="body2" sx={{ fontWeight: index === activeStep ? 700 : 400 }}>
//                     {label}
//                   </Typography>
//                 </StepLabel>
//               </Step>
//             ))}
//           </Stepper>
//         </Box>
//       )}

//       {/* Main Form */}
//       <PremiumCard>
//         <CardHeader
//           title={
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <Person sx={{ fontSize: 32, color: theme.palette.primary.main }} />
//               <Box>
//                 <Typography variant="h5" fontWeight={700}>
//                   Personal Information
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Fill in your details carefully
//                 </Typography>
//               </Box>
//             </Box>
//           }
//           sx={{
//             borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//             pb: 2,
//           }}
//           action={
//             !isMobile && (
//               <Chip 
//                 icon={<Security />}
//                 label="Secured Connection"
//                 color="success"
//                 variant="outlined"
//               />
//             )
//           }
//         />

//         <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
//           {/* Personal Details Section */}
//           <SectionCard sx={{ mb: 4 }}>
//             <CardContent>
//               {renderSectionHeader("Personal Details", <Person />, "personal")}
              
//               {expandedSections.personal && (
//                 <Grid container spacing={3}>
//                   {/* Profile Photo Column */}
//                   <Grid 
//                     item 
//                     xs={12} 
//                     md={4}
//                     sx={{ 
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                     }}
//                   >
//                     {renderProfileUploadSection()}
                    
//                     {/* Quick Stats */}
//                     {/* <Box sx={{ 
//                       width: '100%', 
//                       mt: 3,
//                       p: 2,
//                       borderRadius: 2,
//                       background: alpha(theme.palette.primary.main, 0.05),
//                       border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                     }}>
//                       <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1, color: 'primary.main' }}>
//                         Profile Status
//                       </Typography>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                         <Typography variant="caption" color="text.secondary">Completion</Typography>
//                         <Typography variant="caption" fontWeight={600}>{progress}%</Typography>
//                       </Box>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                         <Typography variant="caption" color="text.secondary">Last Updated</Typography>
//                         <Typography variant="caption" fontWeight={600}>Today</Typography>
//                       </Box>
//                     </Box> */}
//                   </Grid>

//                   {/* Form Fields Column */}
//                   <Grid item xs={12} md={8}>
//                     <Grid container spacing={2}>
//                       {/* Personal Information Grid */}
//                       {[
//                         { 
//                           label: "First Name", 
//                           required: true, 
//                           fieldName: "firstName", 
//                           xs: 12, 
//                           sm: 4,
//                           icon: <Person fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Middle Name", 
//                           required: false, 
//                           fieldName: "middleName", 
//                           xs: 12, 
//                           sm: 4,
//                           icon: <Person fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Last Name", 
//                           required: true, 
//                           fieldName: "lastName", 
//                           xs: 12, 
//                           sm: 4,
//                           icon: <Person fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Father's Name", 
//                           required: true, 
//                           fieldName: "fatherName", 
//                           xs: 12, 
//                           sm: 6,
//                           icon: <Person fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Mother's Name", 
//                           required: true, 
//                           fieldName: "motherName", 
//                           xs: 12, 
//                           sm: 6,
//                           icon: <Person fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                       ].map((field) => (
//                         <Grid item xs={field.xs} sm={field.sm} key={field.fieldName}>
//                           <PremiumTextField
//                             fullWidth
//                             label={field.label}
//                             value={formData[field.fieldName] || ""}
//                             onChange={(e) => handleChange(field.fieldName, e)}
//                             required={field.required}
//                             size="small"
//                             InputProps={{
//                               startAdornment: field.icon && (
//                                 <InputAdornment position="start">
//                                   {field.icon}
//                                 </InputAdornment>
//                               ),
//                             }}
//                           />
//                         </Grid>
//                       ))}

//                       {/* Contact Information Grid */}
//                       <Grid item xs={12}>
//                         <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2, mt: 1, color: 'primary.main' }}>
//                           Contact Information
//                         </Typography>
//                       </Grid>
                      
//                       {[
//                         { 
//                           label: "Date of Birth", 
//                           required: true, 
//                           type: "date", 
//                           fieldName: "dateOfBirth", 
//                           xs: 12, 
//                           sm: 4,
//                           icon: <Cake fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Email ID", 
//                           required: true, 
//                           type: "email", 
//                           fieldName: "email", 
//                           xs: 12, 
//                           sm: 4,
//                           icon: <Email fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Phone Number", 
//                           required: true, 
//                           type: "tel", 
//                           fieldName: "phoneNumber", 
//                           xs: 12, 
//                           sm: 4,
//                           icon: <Phone fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                         { 
//                           label: "Alternative Phone", 
//                           required: false, 
//                           type: "tel", 
//                           fieldName: "alternativePhoneNumber", 
//                           xs: 12, 
//                           sm: 6,
//                           icon: <ContactPhone fontSize="small" sx={{ opacity: 0.7 }} />
//                         },
//                       ].map((field) => (
//                         <Grid item xs={field.xs} sm={field.sm} key={field.fieldName}>
//                           <PremiumTextField
//                             fullWidth
//                             label={field.label}
//                             type={field.type || "text"}
//                             value={formData[field.fieldName] || ""}
//                             onChange={(e) => handleChange(field.fieldName, e)}
//                             required={field.required}
//                             size="small"
//                             InputProps={{
//                               startAdornment: field.icon && (
//                                 <InputAdornment position="start">
//                                   {field.icon}
//                                 </InputAdornment>
//                               ),
//                               ...(field.type === "date" && { shrink: true }),
//                             }}
//                             InputLabelProps={field.type === "date" ? { shrink: true } : {}}
//                           />
//                         </Grid>
//                       ))}

//                       {/* Dropdown Fields */}
//                       <Grid item xs={12} sm={4}>
//                         <FormControl fullWidth size="small">
//                           <InputLabel>Gender *</InputLabel>
//                           <Select
//                             value={formData.gender || ""}
//                             onChange={(e) => handleChange("gender", e)}
//                             label="Gender *"
//                             sx={{ borderRadius: 2 }}
//                           >
//                             <MenuItem value="">
//                               <em>Select Gender</em>
//                             </MenuItem>
//                             <MenuItem value="Male">Male</MenuItem>
//                             <MenuItem value="Female">Female</MenuItem>
//                             <MenuItem value="Other">Other</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} sm={4}>
//                         <FormControl fullWidth size="small">
//                           <InputLabel>Blood Group *</InputLabel>
//                           <Select
//                             value={formData.bloodGroup || ""}
//                             onChange={(e) => handleChange("bloodGroup", e)}
//                             label="Blood Group *"
//                             sx={{ borderRadius: 2 }}
//                             startAdornment={
//                               <InputAdornment position="start">
//                                 <Bloodtype fontSize="small" sx={{ opacity: 0.7, ml: 1 }} />
//                               </InputAdornment>
//                             }
//                           >
//                             <MenuItem value="">
//                               <em>Select Blood Group</em>
//                             </MenuItem>
//                             {["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map((group) => (
//                               <MenuItem key={group} value={group}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                   <Bloodtype fontSize="small" sx={{ color: '#f44336' }} />
//                                   {group}
//                                 </Box>
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} sm={4}>
//                         <FormControl fullWidth size="small">
//                           <InputLabel>Marital Status *</InputLabel>
//                           <Select
//                             value={formData.maritalStatus || ""}
//                             onChange={(e) => handleChange("maritalStatus", e)}
//                             label="Marital Status *"
//                             sx={{ borderRadius: 2 }}
//                             startAdornment={
//                               <InputAdornment position="start">
//                                 <Favorite fontSize="small" sx={{ opacity: 0.7, ml: 1 }} />
//                               </InputAdornment>
//                             }
//                           >
//                             <MenuItem value="">
//                               <em>Select Status</em>
//                             </MenuItem>
//                             <MenuItem value="Single">Single</MenuItem>
//                             <MenuItem value="Married">Married</MenuItem>
//                             <MenuItem value="Divorced">Divorced</MenuItem>
//                             <MenuItem value="Widowed">Widowed</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               )}
//             </CardContent>
//           </SectionCard>

//           {/* Address Section */}
//           <SectionCard sx={{ mb: 4 }}>
//             <CardContent>
//               {renderSectionHeader("Address Details", <Home />, "address")}
              
//               {expandedSections.address && (
//                 <>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Add multiple addresses (Current, Permanent, Office, etc.)
//                     </Typography>
//                     <Button
//                       variant="contained"
//                       startIcon={<Add />}
//                       onClick={() => setOpenAddressDialog(true)}
//                       sx={{ borderRadius: 2 }}
//                     >
//                       Add New Address
//                     </Button>
//                   </Box>

//                   {addresses.length > 0 ? (
//                     <TableContainer 
//                       component={Paper} 
//                       variant="outlined"
//                       sx={{ 
//                         borderRadius: 2,
//                         border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                       }}
//                     >
//                       <Table>
//                         <TableHead sx={{ 
//                           backgroundColor: alpha(theme.palette.primary.main, 0.05) 
//                         }}>
//                           <TableRow>
//                             {[
//                               "Type", "Country", "State", "City", 
//                               "House No.", "Area", "Landmark", "Pincode", "Actions"
//                             ].map((header) => (
//                               <TableCell 
//                                 key={header}
//                                 sx={{ 
//                                   fontWeight: 600,
//                                   color: 'primary.main',
//                                   whiteSpace: 'nowrap'
//                                 }}
//                               >
//                                 {header}
//                               </TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {addresses.map((address, index) => (
//                             <TableRow 
//                               key={index} 
//                               sx={{ 
//                                 '&:hover': { 
//                                   backgroundColor: alpha(theme.palette.primary.main, 0.02) 
//                                 } 
//                               }}
//                             >
//                               <TableCell>
//                                 <Chip 
//                                   label={address.type || "Home"} 
//                                   size="small" 
//                                   color="primary"
//                                   variant="outlined"
//                                 />
//                               </TableCell>
//                               <TableCell>{address.country || "-"}</TableCell>
//                               <TableCell>{address.state || "-"}</TableCell>
//                               <TableCell>{address.city || "-"}</TableCell>
//                               <TableCell>{address.houseNo || "-"}</TableCell>
//                               <TableCell>{address.area || "-"}</TableCell>
//                               <TableCell>{address.landmark || "-"}</TableCell>
//                               <TableCell>
//                                 <Chip 
//                                   label={address.pincode || "-"} 
//                                   size="small" 
//                                   variant="outlined"
//                                 />
//                               </TableCell>
//                               <TableCell>
//                                 <Box sx={{ display: 'flex', gap: 1 }}>
//                                   <Tooltip title="Edit">
//                                     <IconButton 
//                                       size="small" 
//                                       color="primary"
//                                       onClick={() => handleEdit(index)}
//                                     >
//                                       <EditIcon fontSize="small" />
//                                     </IconButton>
//                                   </Tooltip>
//                                   <Tooltip title="Delete">
//                                     <IconButton 
//                                       size="small" 
//                                       color="error"
//                                       onClick={() => handleDelete(index)}
//                                     >
//                                       <DeleteIcon fontSize="small" />
//                                     </IconButton>
//                                   </Tooltip>
//                                 </Box>
//                               </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   ) : (
//                     <Box sx={{ 
//                       textAlign: 'center', 
//                       py: 8,
//                       border: `2px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
//                       borderRadius: 2,
//                     }}>
//                       <LocationOn sx={{ fontSize: 48, color: alpha(theme.palette.primary.main, 0.3), mb: 2 }} />
//                       <Typography variant="h6" color="text.secondary" gutterBottom>
//                         No Address Added
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//                         Add your first address to continue
//                       </Typography>
//                       <Button
//                         variant="outlined"
//                         startIcon={<Add />}
//                         onClick={() => setOpenAddressDialog(true)}
//                         sx={{ borderRadius: 2 }}
//                       >
//                         Add Address
//                       </Button>
//                     </Box>
//                   )}
//                 </>
//               )}
//             </CardContent>
//           </SectionCard>

//           {/* KYC Section */}
//           <SectionCard sx={{ mb: 4 }}>
//             <CardContent>
//               {renderSectionHeader("KYC Documents", <Fingerprint />, "kyc")}
              
//               {expandedSections.kyc && (
//                 <Grid container spacing={2}>
//                   {documents.map((doc) => (
//                     <Grid item xs={12} md={6} key={doc.fieldName}>
//                       <DocumentCard required={doc.required}>
//                         <CardContent>
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//                             <Avatar
//                               sx={{
//                                 backgroundColor: alpha(doc.color, 0.1),
//                                 color: doc.color,
//                                 width: 40,
//                                 height: 40,
//                               }}
//                             >
//                               {doc.icon}
//                             </Avatar>
//                             <Box sx={{ flexGrow: 1 }}>
//                               <Typography variant="subtitle1" fontWeight={600}>
//                                 {doc.label}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {doc.required ? "Required Document" : "Optional Document"}
//                               </Typography>
//                             </Box>
//                           </Box>

//                           <PremiumTextField
//                             fullWidth
//                             size="small"
//                             placeholder={`Enter ${doc.label} Number`}
//                             onChange={(e) => handleDocumentChange(doc.fieldName, e)}
//                             sx={{ mb: 2 }}
//                           />

//                           <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                             <Button
//                               variant="outlined"
//                               size="small"
//                               startIcon={<CloudUploadIcon />}
//                               onClick={() => handleUploadClick(doc.fieldName)}
//                               sx={{ flexGrow: 1, borderRadius: 2 }}
//                             >
//                               Upload Document
//                             </Button>
//                             <input
//                               type="file"
//                               id={`fileInput-${doc.fieldName}`}
//                               accept="image/*,.pdf"
//                               style={{ display: "none" }}
//                               onChange={(e) => handleFileChangePreview(e, doc.fieldName)}
//                             />
                            
//                             {selectedFile?.[doc.fieldName] && (
//                               <>
//                                 <Tooltip title="Preview">
//                                   <IconButton 
//                                     size="small" 
//                                     color="primary"
//                                     onClick={() => setPreviewOpen(true)}
//                                   >
//                                     <Visibility fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Remove">
//                                   <IconButton 
//                                     size="small" 
//                                     color="error"
//                                     onClick={() => {
//                                       setSelectedFile(prev => {
//                                         const newFile = { ...prev };
//                                         delete newFile[doc.fieldName];
//                                         return newFile;
//                                       });
//                                     }}
//                                   >
//                                     <Close fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}
//                           </Box>

//                           {uploadProgress[doc.fieldName] !== null && (
//                             <Box sx={{ mt: 1 }}>
//                               <LinearProgress 
//                                 variant="determinate" 
//                                 value={uploadProgress[doc.fieldName]}
//                                 sx={{
//                                   height: 4,
//                                   borderRadius: 2,
//                                   backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                                   '& .MuiLinearProgress-bar': {
//                                     backgroundColor: doc.color,
//                                     borderRadius: 2,
//                                   }
//                                 }}
//                               />
//                             </Box>
//                           )}
//                         </CardContent>
//                       </DocumentCard>
//                     </Grid>
//                   ))}
//                 </Grid>
//               )}
//             </CardContent>
//           </SectionCard>

//           {/* Bank Details Section */}
//           <SectionCard sx={{ mb: 4 }}>
//             <CardContent>
//               {renderSectionHeader("Bank Details", <AccountBalance />, "bank")}
              
//               {expandedSections.bank && (
//                 <>
//                   <Box sx={{ mb: 3 }}>
//                     <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                       Select Account Type
//                     </Typography>
//                     <RadioGroup
//                       row
//                       value={bankOption}
//                       onChange={(e) => setBankOption(e.target.value)}
//                       sx={{ gap: 3 }}
//                     >
//                       <FormControlLabel
//                         value="existing"
//                         control={
//                           <Radio 
//                             sx={{
//                               '&.Mui-checked': {
//                                 color: theme.palette.primary.main,
//                               },
//                             }}
//                           />
//                         }
//                         label={
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <AccountBalanceWallet />
//                             <Typography>I Have An Account</Typography>
//                           </Box>
//                         }
//                       />
//                       <FormControlLabel
//                         value="new"
//                         control={
//                           <Radio 
//                             sx={{
//                               '&.Mui-checked': {
//                                 color: theme.palette.primary.main,
//                               },
//                             }}
//                           />
//                         }
//                         label={
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <Add />
//                             <Typography>I Need A New Account</Typography>
//                           </Box>
//                         }
//                       />
//                     </RadioGroup>
//                   </Box>

//                   {bankOption === "existing" && (
//                     <>
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                         <Typography variant="body2" color="text.secondary">
//                           Add your bank account details for salary and payments
//                         </Typography>
//                         <Button
//                           variant="contained"
//                           startIcon={<Add />}
//                           onClick={() => setOpenBankDialog(true)}
//                           sx={{ borderRadius: 2 }}
//                         >
//                           Add Bank Account
//                         </Button>
//                       </Box>

//                       {addresses.length > 0 ? (
//                         <TableContainer 
//                           component={Paper} 
//                           variant="outlined"
//                           sx={{ 
//                             borderRadius: 2,
//                             border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                           }}
//                         >
//                           <Table>
//                             <TableHead sx={{ 
//                               backgroundColor: alpha(theme.palette.primary.main, 0.05) 
//                             }}>
//                               <TableRow>
//                                 {[
//                                   "Account Holder Name",
//                                   "Bank Name",
//                                   "Account Number",
//                                   "IFSC Code",
//                                   "Branch Name",
//                                   "Actions"
//                                 ].map((header) => (
//                                   <TableCell 
//                                     key={header}
//                                     sx={{ 
//                                       fontWeight: 600,
//                                       color: 'primary.main',
//                                       whiteSpace: 'nowrap'
//                                     }}
//                                   >
//                                     {header}
//                                   </TableCell>
//                                 ))}
//                               </TableRow>
//                             </TableHead>
//                             <TableBody>
//                               {addresses.map((_, index) => (
//                                 <TableRow 
//                                   key={index}
//                                   sx={{ 
//                                     '&:hover': { 
//                                       backgroundColor: alpha(theme.palette.primary.main, 0.02) 
//                                     } 
//                                   }}
//                                 >
//                                   <TableCell>
//                                     <Typography fontWeight={500}>John Doe</Typography>
//                                   </TableCell>
//                                   <TableCell>State Bank of India</TableCell>
//                                   <TableCell>
//                                     <Typography variant="body2" fontFamily="monospace">
//                                       **** **** 1234
//                                     </Typography>
//                                   </TableCell>
//                                   <TableCell>
//                                     <Chip 
//                                       label="SBIN0001234" 
//                                       size="small" 
//                                       color="primary"
//                                       variant="outlined"
//                                     />
//                                   </TableCell>
//                                   <TableCell>Main Branch</TableCell>
//                                   <TableCell>
//                                     <Box sx={{ display: 'flex', gap: 1 }}>
//                                       <IconButton size="small" color="primary">
//                                         <EditIcon fontSize="small" />
//                                       </IconButton>
//                                       <IconButton size="small" color="error">
//                                         <DeleteIcon fontSize="small" />
//                                       </IconButton>
//                                     </Box>
//                                   </TableCell>
//                                 </TableRow>
//                               ))}
//                             </TableBody>
//                           </Table>
//                         </TableContainer>
//                       ) : (
//                         <Box sx={{ 
//                           textAlign: 'center', 
//                           py: 8,
//                           border: `2px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
//                           borderRadius: 2,
//                         }}>
//                           <AccountBalance sx={{ fontSize: 48, color: alpha(theme.palette.primary.main, 0.3), mb: 2 }} />
//                           <Typography variant="h6" color="text.secondary" gutterBottom>
//                             No Bank Account Added
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//                             Add your bank account for salary processing
//                           </Typography>
//                           <Button
//                             variant="outlined"
//                             startIcon={<Add />}
//                             onClick={() => setOpenBankDialog(true)}
//                             sx={{ borderRadius: 2 }}
//                           >
//                             Add Bank Account
//                           </Button>
//                         </Box>
//                       )}
//                     </>
//                   )}
//                 </>
//               )}
//             </CardContent>
//           </SectionCard>

//           {/* Social Profiles Section */}
//           <SectionCard sx={{ mb: 4 }}>
//             <CardContent>
//               {renderSectionHeader("Social Profiles", <Share />, "social")}
              
//               {expandedSections.social && (
//                 <>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//                     Connect your social profiles (Optional)
//                   </Typography>
                  
//                   <Grid container spacing={2}>
//                     {socialProfiles.map((profile) => (
//                       <Grid item xs={12} sm={6} key={profile.fieldName}>
//                         <PremiumTextField
//                           fullWidth
//                           label={profile.label}
//                           type={profile.type}
//                           placeholder={`Enter ${profile.label} ${profile.type === 'url' ? 'URL' : 'Number'}`}
//                           size="small"
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 {profile.icon}
//                               </InputAdornment>
//                             ),
//                           }}
//                         />
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </>
//               )}
//             </CardContent>
//           </SectionCard>
//         </CardContent>

//         {/* Action Buttons */}
//         <CardActions sx={{ 
//           p: 3, 
//           borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           justifyContent: 'space-between',
//           flexDirection: isMobile ? 'column' : 'row',
//           gap: isMobile ? 2 : 0,
//         }}>
//           <Button
//             variant="outlined"
//             onClick={() => setActiveStep(prev => Math.max(0, prev - 1))}
//             disabled={activeStep === 0}
//             sx={{ borderRadius: 2 }}
//           >
//             Previous Step
//           </Button>
          
//           <Box sx={{ display: 'flex', gap: 2, flexDirection: isMobile ? 'column' : 'row', width: isMobile ? '100%' : 'auto' }}>
//             <Button 
//               variant="outlined" 
//               color="secondary"
//               sx={{ borderRadius: 2 }}
//               startIcon={<Save />}
//             >
//               Save as Draft
//             </Button>
//             <GradientButton
//               onClick={handleSubmit}
//               startIcon={<CheckCircle />}
//               sx={{ 
//                 minWidth: isMobile ? '100%' : 200,
//                 background: `linear-gradient(45deg, ${theme.palette.success.main} 30%, ${theme.palette.success.dark} 90%)`,
//               }}
//             >
//               Submit All Details
//             </GradientButton>
//           </Box>
//         </CardActions>
//       </PremiumCard>

//       {/* Address Dialog */}
//       <Dialog 
//         open={openAddressDialog} 
//         onClose={() => setOpenAddressDialog(false)} 
//         maxWidth="sm" 
//         fullWidth
//         PaperProps={{
//           sx: { borderRadius: 3 }
//         }}
//       >
//         <DialogTitle sx={{ 
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           pb: 2,
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <LocationOn color="primary" />
//             <Typography variant="h6">Add New Address</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           <Grid container spacing={2}>
//             {[
//               { label: "Address Type", name: "type", sm: 12 },
//               { label: "Country", name: "country", sm: 6 },
//               { label: "State", name: "state", sm: 6 },
//               { label: "City", name: "city", sm: 6 },
//               { label: "Pincode", name: "pincode", sm: 6 },
//               { label: "House No./Building", name: "houseNo", sm: 12 },
//               { label: "Area/Street", name: "area", sm: 12 },
//               { label: "Landmark", name: "landmark", sm: 12 },
//             ].map((field) => (
//               <Grid item xs={12} sm={field.sm} key={field.name}>
//                 <PremiumTextField
//                   fullWidth
//                   label={field.label}
//                   size="small"
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 3, pt: 0 }}>
//           <Button 
//             onClick={() => setOpenAddressDialog(false)}
//             sx={{ borderRadius: 2 }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             onClick={() => setOpenAddressDialog(false)}
//             sx={{ borderRadius: 2 }}
//           >
//             Save Address
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Preview Dialog */}
//       <Dialog 
//         open={previewOpen} 
//         onClose={() => setPreviewOpen(false)} 
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: { borderRadius: 3 }
//         }}
//       >
//         <DialogTitle sx={{ 
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           pb: 2,
//         }}>
//           Document Preview
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           {selectedFile && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'center',
//               alignItems: 'center',
//               minHeight: 400,
//             }}>
//               <img
//                 src={Object.values(selectedFile)[0]}
//                 alt="Preview"
//                 style={{ 
//                   maxWidth: '100%', 
//                   maxHeight: '70vh',
//                   borderRadius: 8,
//                   boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.15)}`,
//                 }}
//               />
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ p: 3, pt: 0 }}>
//           <Button 
//             onClick={() => setPreviewOpen(false)}
//             sx={{ borderRadius: 2 }}
//           >
//             Close
//           </Button>
//           <Button 
//             variant="contained" 
//             onClick={() => setPreviewOpen(false)}
//             sx={{ borderRadius: 2 }}
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert 
//           severity={snackbar.severity} 
//           onClose={handleCloseSnackbar}
//           variant="filled"
//           sx={{ 
//             borderRadius: 2,
//             boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.15)}`,
//           }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       {/* Mobile Floating Action Button */}
//       {isMobile && (
//         <Fab
//           color="primary"
//           aria-label="submit"
//           onClick={handleSubmit}
//           sx={{
//             position: "fixed",
//             bottom: 20,
//             right: 20,
//             background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//           }}
//         >
//           <CheckCircle />
//         </Fab>
//       )}
//     </Container>
//   );
// };

// export default PersonalDetailsForm;



// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   TextField,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Typography,
//   Snackbar,
//   Alert,
//   Container,
//   Card,
//   CardContent,
//   CardHeader,
//   IconButton,
//   InputAdornment,
//   Divider,
//   Stepper,
//   Step,
//   StepLabel,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Avatar,
//   Chip,
//   Tooltip,
//   Fab,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import {
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   CloudUpload as CloudUploadIcon,
//   PhotoCamera,
//   Visibility,
//   Close,
//   Save,
//   Add,
//   Person,
//   Home,
//   AccountBalance,
//   Fingerprint,
//   Share,
//   CheckCircle,
//   ExpandMore,
//   ExpandLess,
// } from "@mui/icons-material";

// const PersonalDetailsForm = () => {
//   // State management
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     fatherName: "",
//     motherName: "",
//     dateOfBirth: "",
//     email: "",
//     phoneNumber: "",
//     alternativePhoneNumber: "",
//     gender: "",
//     bloodGroup: "",
//     maritalStatus: "",
//     addresses: [],
//     bankDetails: [],
//     socialProfiles: {},
//   });
//   const [addresses, setAddresses] = useState([{}]);
//   const [openAddressDialog, setOpenAddressDialog] = useState(false);
//   const [openBankDialog, setOpenBankDialog] = useState(false);
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [bankOption, setBankOption] = useState("existing");
//   const [activeStep, setActiveStep] = useState(0);
//   const [expandedSections, setExpandedSections] = useState({
//     personal: true,
//     address: false,
//     kyc: false,
//     bank: false,
//     social: false,
//   });
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   // Document lists
//   const documents = [
//     { label: "Aadhar Card", required: true, fieldName: "aadharCard", icon: "🆔" },
//     { label: "PAN Card", required: true, fieldName: "panCard", icon: "💳" },
//     { label: "Driving License", required: false, fieldName: "drivingLicense", icon: "🚗" },
//     { label: "Passport", required: false, fieldName: "passport", icon: "🛂" },
//     { label: "Voter ID", required: false, fieldName: "voterId", icon: "🗳️" },
//   ];

//   const socialProfiles = [
//     { label: "LinkedIn", required: false, type: "url", fieldName: "linkedIn", icon: "💼" },
//     { label: "Facebook", required: false, type: "url", fieldName: "facebook", icon: "👥" },
//     { label: "Twitter", required: false, type: "url", fieldName: "twitter", icon: "🐦" },
//     { label: "Instagram", required: false, type: "url", fieldName: "instagram", icon: "📸" },
//   ];

//   const steps = ["Personal Details", "Address", "KYC", "Bank Details", "Social Profiles"];

//   // Handler functions
//   const handleImageUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSelectedImage(reader.result);
//         setFormData((prev) => ({
//           ...prev,
//           profilePhoto: reader.result,
//         }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleChange = (field, event) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: event.target.value,
//     }));
//   };

//   const handleSocialProfileChange = (field, event) => {
//     setFormData((prev) => ({
//       ...prev,
//       socialProfiles: {
//         ...prev.socialProfiles,
//         [field]: event.target.value,
//       },
//     }));
//   };

//   const handleDocumentChange = (field, event) => {
//     setFormData((prev) => ({
//       ...prev,
//       documents: {
//         ...prev.documents,
//         [field]: event.target.value,
//       },
//     }));
//   };

//   const handleEdit = (index) => {
//     // Edit functionality
//   };

//   const handleDelete = (index) => {
//     // Delete functionality
//   };

//   const handleUploadClick = (field) => {
//     document.getElementById(`fileInput-${field}`).click();
//   };

//   const handleFileChangePreview = (event, field) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setSelectedFile({ [field]: reader.result });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         ...formData,
//         addresses: addresses,
//       };

//       const response = await fetch("http://10.10.222.56:8283/Personal/add", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) throw new Error("Failed to submit personal details");

//       const data = await response.json();
//       setSnackbar({
//         open: true,
//         message: "Personal details submitted successfully!",
//         severity: "success",
//       });
//     } catch (error) {
//       console.error("Error:", error);
//       setSnackbar({
//         open: true,
//         message: "Failed to submit. Please try again.",
//         severity: "error",
//       });
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const toggleSection = (section) => {
//     setExpandedSections(prev => ({
//       ...prev,
//       [section]: !prev[section]
//     }));
//   };

//   const renderSectionHeader = (title, icon, section) => (
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         backgroundColor: theme.palette.primary.main,
//         color: "white",
//         p: 2,
//         borderRadius: 1,
//         cursor: "pointer",
//         mb: 2,
//       }}
//       onClick={() => toggleSection(section)}
//     >
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//         {icon}
//         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//           {title}
//         </Typography>
//       </Box>
//       {expandedSections[section] ? <ExpandLess /> : <ExpandMore />}
//     </Box>
//   );

//   return (
//     <Container maxWidth="lg" sx={{ py: 3 }}>
//       {/* Progress Stepper */}
//       <Stepper
//         activeStep={activeStep}
//         alternativeLabel
//         sx={{
//           mb: 4,
//           display: isMobile ? "none" : "flex",
//         }}
//       >
//         {steps.map((label) => (
//           <Step key={label}>
//             <StepLabel>{label}</StepLabel>
//           </Step>
//         ))}
//       </Stepper>

//       {/* Main Form Container */}
//       <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
//         <CardHeader
//   title="Personal Details Form"
//   subheader="Complete all sections with accurate information"
//   sx={{
//     background: "linear-gradient(135deg, #7564e6, #7564e6)",
//     color: "white",
//     borderTopLeftRadius: 8,
//     borderTopRightRadius: 8,
//   }}
// />


//         <CardContent sx={{ p: isMobile ? 2 : 3 }}>
//           {/* Personal Details Section */}
//           <Box sx={{ mb: 4 }}>
//             {renderSectionHeader("Personal Details", <Person />, "personal")}
            
//             {expandedSections.personal && (
//               <Grid container spacing={3}>
//                 {/* Profile Photo Upload */}
//                 <Grid item xs={12} md={3}>
//                   <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//                     <Avatar
//                       src={selectedImage}
//                       sx={{
//                         width: 140,
//                         height: 140,
//                         mb: 2,
//                         border: "3px solid",
//                         borderColor: theme.palette.primary.light,
//                       }}
//                     >
//                       {!selectedImage && <PhotoCamera sx={{ fontSize: 40 }} />}
//                     </Avatar>
                    
//                     <Button
//                       variant="outlined"
//                       component="label"
//                       startIcon={<CloudUploadIcon />}
//                       sx={{ mb: 1 }}
//                     >
//                       Upload Photo
//                       <input
//                         type="file"
//                         accept="image/*"
//                         hidden
//                         onChange={handleImageUpload}
//                       />
//                     </Button>
                    
//                     <Typography variant="caption" color="text.secondary" align="center">
//                       JPEG/PNG • 1MB-2MB
//                     </Typography>
//                   </Box>
//                 </Grid>

//                 {/* Personal Details Form */}
//                 <Grid item xs={12} md={9}>
//                   <Grid container spacing={2}>
//                     {[
//                       { label: "First Name", required: true, fieldName: "firstName", xs: 12, sm: 4 },
//                       { label: "Middle Name", required: false, fieldName: "middleName", xs: 12, sm: 4 },
//                       { label: "Last Name", required: true, fieldName: "lastName", xs: 12, sm: 4 },
//                       { label: "Father Name", required: true, fieldName: "fatherName", xs: 12, sm: 6 },
//                       { label: "Mother Name", required: true, fieldName: "motherName", xs: 12, sm: 6 },
//                       { label: "Date of Birth", required: true, type: "date", fieldName: "dateOfBirth", xs: 12, sm: 4 },
//                       { label: "Email ID", required: true, type: "email", fieldName: "email", xs: 12, sm: 4 },
//                       { label: "Phone Number", required: true, type: "tel", fieldName: "phoneNumber", xs: 12, sm: 4 },
//                       { label: "Alternative Phone", required: false, type: "tel", fieldName: "alternativePhoneNumber", xs: 12, sm: 6 },
//                     ].map((field) => (
//                       <Grid item xs={field.xs} sm={field.sm} key={field.fieldName}>
//                         <TextField
//                           fullWidth
//                           label={field.label}
//                           type={field.type || "text"}
//                           value={formData[field.fieldName] || ""}
//                           onChange={(e) => handleChange(field.fieldName, e)}
//                           required={field.required}
//                           variant="outlined"
//                           size="small"
//                           InputLabelProps={field.type === "date" ? { shrink: true } : {}}
//                         />
//                       </Grid>
//                     ))}

//                     {/* Dropdown Fields */}
//                     <Grid item xs={12} sm={4}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Gender *</InputLabel>
//                         <Select
//                           value={formData.gender || ""}
//                           onChange={(e) => handleChange("gender", e)}
//                           label="Gender *"
//                         >
//                           <MenuItem value="">Select</MenuItem>
//                           <MenuItem value="Male">Male</MenuItem>
//                           <MenuItem value="Female">Female</MenuItem>
//                           <MenuItem value="Other">Other</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} sm={4}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Blood Group *</InputLabel>
//                         <Select
//                           value={formData.bloodGroup || ""}
//                           onChange={(e) => handleChange("bloodGroup", e)}
//                           label="Blood Group *"
//                         >
//                           <MenuItem value="">Select</MenuItem>
//                           {["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map((group) => (
//                             <MenuItem key={group} value={group}>{group}</MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} sm={4}>
//                       <FormControl fullWidth size="small">
//                         <InputLabel>Marital Status *</InputLabel>
//                         <Select
//                           value={formData.maritalStatus || ""}
//                           onChange={(e) => handleChange("maritalStatus", e)}
//                           label="Marital Status *"
//                         >
//                           <MenuItem value="">Select</MenuItem>
//                           <MenuItem value="Single">Single</MenuItem>
//                           <MenuItem value="Married">Married</MenuItem>
//                           <MenuItem value="Divorced">Divorced</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             )}
//           </Box>

//           {/* <Divider sx={{ my: 4 }} /> */}

//           {/* Address Section */}
//           <Box sx={{ mb: 4 }}>
//             {renderSectionHeader("Address Details", <Home />, "address")}
            
//             {expandedSections.address && (
//               <>
//                 <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
//                   <Button
//                     variant="contained"
//                     startIcon={<Add />}
//                     onClick={() => setOpenAddressDialog(true)}
//                     size="small"
//                   >
//                     Add Address
//                   </Button>
//                 </Box>

//                 <TableContainer 
//                   component={Paper} 
//                   variant="outlined"
//                   sx={{ 
//                     maxHeight: 400,
//                     overflow: 'auto'
//                   }}
//                 >
//                   <Table size="small" stickyHeader>
//                     <TableHead>
//                       <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
//                         {[
//                           "Type", "Country", "State", "City", 
//                           "House No.", "Area", "Landmark", "Pincode", "Actions"
//                         ].map((header) => (
//                           <TableCell 
//                             key={header} 
//                             align="center"
//                             sx={{ 
//                               fontWeight: 600,
//                               whiteSpace: 'nowrap'
//                             }}
//                           >
//                             {header}
//                           </TableCell>
//                         ))}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {addresses.map((address, index) => (
//                         <TableRow key={index} hover>
//                           {[...Array(8)].map((_, i) => (
//                             <TableCell key={i} align="center">
//                               {/* Address data */}
//                             </TableCell>
//                           ))}
//                           <TableCell align="center">
//                             <IconButton size="small" color="primary" onClick={() => handleEdit(index)}>
//                               <EditIcon />
//                             </IconButton>
//                             <IconButton size="small" color="error" onClick={() => handleDelete(index)}>
//                               <DeleteIcon />
//                             </IconButton>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </>
//             )}
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* KYC Section */}
//           <Box sx={{ mb: 4 }}>
//             {renderSectionHeader("KYC Documents", <Fingerprint />, "kyc")}
            
//             {expandedSections.kyc && (
//               <Grid container spacing={2}>
//                 {documents.map((doc) => (
//                   <Grid item xs={12} sm={6} key={doc.fieldName}>
//                     <Card variant="outlined" sx={{ p: 2 }}>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                         <Typography variant="h5">{doc.icon}</Typography>
//                         <Box sx={{ flexGrow: 1 }}>
//                           <Typography variant="subtitle2" fontWeight={600}>
//                             {doc.label}
//                             {doc.required && (
//                               <Chip 
//                                 label="Required" 
//                                 size="small" 
//                                 color="primary" 
//                                 sx={{ ml: 1 }}
//                               />
//                             )}
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             placeholder={`Enter ${doc.label} Number`}
//                             sx={{ mt: 1 }}
//                           />
//                         </Box>
//                         <Box sx={{ display: "flex", gap: 1 }}>
//                           <Button
//                             variant="outlined"
//                             size="small"
//                             onClick={() => handleUploadClick(doc.fieldName)}
//                           >
//                             Upload
//                           </Button>
//                           <input
//                             type="file"
//                             id={`fileInput-${doc.fieldName}`}
//                             accept="image/*"
//                             style={{ display: "none" }}
//                             onChange={(e) => handleFileChangePreview(e, doc.fieldName)}
//                           />
//                           {selectedFile?.[doc.fieldName] && (
//                             <>
//                               <IconButton size="small" onClick={() => setPreviewOpen(true)}>
//                                 <Visibility />
//                               </IconButton>
//                               <IconButton size="small" color="error" onClick={() => setSelectedFile(null)}>
//                                 <Close />
//                               </IconButton>
//                             </>
//                           )}
//                         </Box>
//                       </Box>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             )}
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Bank Details Section */}
//           <Box sx={{ mb: 4 }}>
//             {renderSectionHeader("Bank Details", <AccountBalance />, "bank")}
            
//             {expandedSections.bank && (
//               <>
//                 <Box sx={{ mb: 3 }}>
//                   <RadioGroup
//                     row
//                     value={bankOption}
//                     onChange={(e) => setBankOption(e.target.value)}
//                   >
//                     <FormControlLabel
//                       value="existing"
//                       control={<Radio />}
//                       label="I Have An Account"
//                     />
//                     <FormControlLabel
//                       value="new"
//                       control={<Radio />}
//                       label="I Need A New Account"
//                     />
//                   </RadioGroup>
//                 </Box>

//                 {bankOption === "existing" && (
//                   <>
//                     <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end" }}>
//                       <Button
//                         variant="contained"
//                         startIcon={<Add />}
//                         onClick={() => setOpenBankDialog(true)}
//                         size="small"
//                       >
//                         Add Bank Account
//                       </Button>
//                     </Box>

//                     <TableContainer component={Paper} variant="outlined">
//                       <Table size="small">
//                         <TableHead>
//                           <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
//                             {[
//                               "Account Holder Name",
//                               "Bank Name",
//                               "Account Number",
//                               "IFSC Code",
//                               "Branch Name",
//                               "Branch City",
//                               "UAN Number",
//                             ].map((header) => (
//                               <TableCell 
//                                 key={header} 
//                                 align="center"
//                                 sx={{ fontWeight: 600 }}
//                               >
//                                 {header}
//                               </TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {addresses.map((_, index) => (
//                             <TableRow key={index} hover>
//                               {[...Array(7)].map((_, i) => (
//                                 <TableCell key={i} align="center"></TableCell>
//                               ))}
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </>
//                 )}
//               </>
//             )}
//           </Box>

//           <Divider sx={{ my: 4 }} />

//           {/* Social Profiles Section */}
//           <Box sx={{ mb: 4 }}>
//             {renderSectionHeader("Social Profiles", <Share />, "social")}
            
//             {expandedSections.social && (
//               <Grid container spacing={2}>
//                 {socialProfiles.map((profile) => (
//                   <Grid item xs={12} sm={6} md={3} key={profile.fieldName}>
//                     <Box sx={{ position: "relative" }}>
//                       <TextField
//                         fullWidth
//                         label={profile.label}
//                         type="url"
//                         placeholder={`${profile.label} URL`}
//                         size="small"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <Typography variant="h6">{profile.icon}</Typography>
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             )}
//           </Box>

//           {/* Submit Button */}
//           <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
//             <Button
//               variant="outlined"
//               onClick={() => setActiveStep(prev => Math.max(0, prev - 1))}
//               disabled={activeStep === 0}
//             >
//               Back
//             </Button>
            
//             <Box sx={{ display: "flex", gap: 2 }}>
//               <Button variant="outlined" color="secondary">
//                 Save Draft
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={handleSubmit}
//                 startIcon={<CheckCircle />}
//                 sx={{
//                   backgroundColor: "#4CAF50",
//                   "&:hover": { backgroundColor: "#388E3C" },
//                   px: 4,
//                 }}
//               >
//                 Submit All Details
//               </Button>
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Dialogs */}
//       <Dialog open={openAddressDialog} onClose={() => setOpenAddressDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Add New Address</DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             {[
//               { label: "Address Type", name: "type" },
//               { label: "Country", name: "country" },
//               { label: "State", name: "state" },
//               { label: "City", name: "city" },
//               { label: "House No.", name: "houseNo" },
//               { label: "Area", name: "area" },
//               { label: "Landmark", name: "landmark" },
//               { label: "Pincode", name: "pincode" },
//             ].map((field) => (
//               <Grid item xs={12} sm={6} key={field.name}>
//                 <TextField fullWidth label={field.label} size="small" />
//               </Grid>
//             ))}
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenAddressDialog(false)} color="inherit">
//             Cancel
//           </Button>
//           <Button variant="contained" onClick={() => setOpenAddressDialog(false)}>
//             Save Address
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Preview Dialog */}
//       <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md">
//         <DialogTitle>Document Preview</DialogTitle>
//         <DialogContent>
//           {selectedFile && (
//             <img
//               src={Object.values(selectedFile)[0]}
//               alt="Preview"
//               style={{ width: "100%", height: "auto", maxHeight: "70vh" }}
//             />
//           )}
//         </DialogContent>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       {/* Floating Action Button for Mobile */}
//       {isMobile && (
//         <Fab
//           color="primary"
//           aria-label="submit"
//           onClick={handleSubmit}
//           sx={{
//             position: "fixed",
//             bottom: 16,
//             right: 16,
//           }}
//         >
//           <Save />
//         </Fab>
//       )}
//     </Container>
//   );
// };

// export default PersonalDetailsForm;



import React, { useState } from "react";
import "./Personal.css";

const PersonalProfileForm = () => {
  const [profilePic, setProfilePic] = useState(null);

  const handleProfileUpload = (e) => {
    const file = e.target.files[0];
    if (file) setProfilePic(URL.createObjectURL(file));
  };

  return (
    <div className="layout">
      {/* LEFT PROFILE BOX */}
      {/* <div className="profile-box">
        <img
          src={
            profilePic ||
            "https://cdn-icons-png.flaticon.com/512/847/847969.png"
          }
          alt="Profile"
        />

        <label className="upload-btn">
          Change Photo
          <input type="file" accept="image/*" onChange={handleProfileUpload} />
        </label>
      </div> */}

      {/* RIGHT FORM SIDE */}
      <div className="right-form">
        <Card title="Personal Information">
  <div className="personal-row">
    
    {/* LEFT IMAGE COLUMN */}
    <div className="profile-box">
      <img
        src={
          profilePic ||
          "https://cdn-icons-png.flaticon.com/512/847/847969.png"
        }
        alt="Profile"
      />

      <label className="upload-btn">
        Change Photo
        <input
          type="file"
          accept="image/*"
          onChange={handleProfileUpload}
        />
      </label>
    </div>

    {/* RIGHT FORM COLUMN */}
    <div className="personal-form">
      <Grid>
        <Input label="First Name" required />
        <Input label="Middle Name" />
        <Input label="Last Name" required />
        <Input label="Father Name" required />
        <Input label="Mother Name" required />
        <Input label="Date of Birth" type="date" required />
        <Input label="Email ID" type="email" required />
        <Input label="Phone Number" type="tel" required />
        <Input label="Alternative Phone" type="tel" />
      </Grid>
    </div>

  </div>
</Card>


        <Card title="Address Details">
          <Grid>
            <Input label="Address Type" />
            <Input label="Country" />
            <Input label="State" />
            <Input label="City" />
            <Input label="House No." />
            <Input label="Area" />
            <Input label="Landmark" />
            <Input label="Pincode" />
          </Grid>
        </Card>

        <Card title="KYC Documents">
          <Grid>
            <File label="🆔 Aadhar Card" />
            <File label="💳 PAN Card" />
            <File label="🚗 Driving License" />
            <File label="🛂 Passport" />
            <File label="🗳️ Voter ID" />
          </Grid>
        </Card>

        <Card title="Bank Details">
          <Grid>
            <Input label="Account Holder Name" />
            <Input label="Bank Name" />
            <Input label="Account Number" />
            <Input label="IFSC Code" />
            <Input label="Branch Name" />
            <Input label="Branch City" />
            <Input label="UAN Number" />
          </Grid>
        </Card>

        <Card title="Social Media">
          <Grid>
            <Input label="LinkedIn" type="url" />
            <Input label="Facebook" type="url" />
            <Input label="Twitter" type="url" />
            <Input label="Instagram" type="url" />
          </Grid>
        </Card>

        <button className="save-btn">Save Profile</button>
      </div>
    </div>
  );
};

const Card = ({ title, children }) => (
  <div className="card">
    <h3>{title}</h3>
    {children}
  </div>
);

const Grid = ({ children }) => (
  <div className="grid">{children}</div>
);

const Input = ({ label, type = "text", required }) => (
  <div className="field">
    <label>
      {label} {required && <span>*</span>}
    </label>
    <input type={type} />
  </div>
);

const File = ({ label }) => (
  <div className="field">
    <label>{label}</label>
    <input type="file" />
  </div>
);

export default PersonalProfileForm;
